import React from "react";
import { createPortal } from "react-dom";

const createRootElement = (id: string) => {
  const rootContainer = document.createElement("div");
  rootContainer.id = id;
  return rootContainer;
};

const addRootElement = (rootElem: HTMLElement) => {
  document.body.appendChild(rootElem);
};

interface PortalPropTypes {
  visible?: boolean;
  rootID: string;
  children?: any;
}

export const getProtalElement = (rootID) => {
  const existingPortalElem = document.getElementById(rootID);
  if (!existingPortalElem) {
    const parentElem = createRootElement(rootID);
    addRootElement(parentElem);
    return parentElem;
  }
};

const Portal = (props: PortalPropTypes) => {
  const { rootID, children, visible } = props;
  const [portalElement, setPortalElem] = React.useState<any>(undefined);

  const getRootElem = React.useCallback(() => {
    const existingPortalElem = document.getElementById(rootID);
    if (!existingPortalElem) {
      const parentElem = createRootElement(rootID);
      addRootElement(parentElem);
      return parentElem;
    }
    return existingPortalElem;
  }, [rootID]);

  React.useEffect(() => {
    return () => {
      const rootContainer = document.getElementById(rootID);
      if (rootContainer) {
        rootContainer.parentNode?.removeChild(rootContainer);
      }
    };
  }, [rootID]);

  React.useEffect(() => {
    if (visible) {
      setPortalElem(getRootElem());
    }
  }, [visible, setPortalElem, getRootElem, rootID]);

  if (portalElement) {
    return createPortal(children, portalElement);
  } else {
    return null;
  }
};

export default Portal;
